import React from 'react';
import { Grid, Separator, Text } from 'telia-front-react';
import { TRANSLATIONS_APP_NAME, TranslationsContext } from '@telia-common-components/shared';
import TradeInConditions from './TradeInConditions';
import TradeInMaxPrice from './TradeInMaxPrice';
import TradeInSelectors from './TradeInSelectors';
const TradeInSelection = ({ headingElement, translate, tradeInStore }) => {
    const { translations } = React.useContext(TranslationsContext);
    return (React.createElement(Text, null,
        React.createElement(Grid, { align: ['center-xs'] },
            React.createElement(TradeInSelectors, { translate: translate, tradeInStore: tradeInStore })),
        Object.keys((translations === null || translations === void 0 ? void 0 : translations[TRANSLATIONS_APP_NAME]) || {}).length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(Grid, { align: ['center-xs'] },
                React.createElement(TradeInMaxPrice, { translate: translate, tradeInStore: tradeInStore })),
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement(TradeInConditions, { headingElement: headingElement, translate: translate, tradeInStore: tradeInStore })))));
};
export default TradeInSelection;
